import React, { useState, useEffect } from 'react';
import { Field, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import * as S from './style';

const linkify = (text, url) => {
  if (!text) return '';

  const reg = /(.+?)?\|(.+?)?\|(.+w?)?/g;
  const match = reg.exec(text);
  if (!match) return null;
  const [, before, inside, after] = match;

  return (
    <React.Fragment>
      {before}
      <a href={url} target="_blank" rel="noreferrer">
        {inside}
      </a>
      {after}
    </React.Fragment>
  );
};

const CheckboxInput = ({ name, error, touched, tkey, options, mandatory }) => {
  const { t } = useTranslation();
  const {
    values: { [name]: checked },
  } = useFormikContext();
  const [link, setLink] = useState(null);

  useEffect(() => {
    if (options?.link) {
      setLink(options?.link);
    }
  }, [options?.link]);

  let text = t(tkey);

  return (
    <S.CheckboxLabel htmlFor={name} className={error ? 'error' : touched && 'valid'}>
      <Field name={name} id={name} type="checkbox" />
      <div className={`checkbox-style ${checked ? 'checkbox-style--checked' : ''}`}></div>
      {link ? (
        <span>
          {linkify(t(tkey), link)}
          {mandatory ? <span className="red">*</span> : ''}
        </span>
      ) : (
        <span>
          {text}
          {mandatory ? <span className="red">*</span> : ''}
        </span>
      )}
    </S.CheckboxLabel>
  );
};

export default CheckboxInput;

CheckboxInput.propTypes = {
  name: PropTypes.string,
  error: PropTypes.string,
  touched: PropTypes.bool,
  tkey: PropTypes.string,
  options: PropTypes.object,
  mandatory: PropTypes.bool,
};
